<template>
    <div class="row gx-3">
        <pc-label
            v-bind:label="label"
            v-bind:for-id="inputId"
            v-bind:show-required="required"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            class="col-12"
            v-on:help-clicked="emitHelpClicked" />
        <div class="col-12">
            <slot name="help" />
        </div>
        <pc-input-group v-bind:class="responsiveHelpers.standard">
            <pc-select
                v-bind="binder"
                v-bind:options="options"
                value-prop="UserId"
                text-prop="Name"
                data-test-role="dropdownlist-element"
                v-on:update:model-value="sendDataChange(dataFieldId, $event)">
                <option value="">
                    {{ selectDefaultValue }}
                </option>
            </pc-select>
        </pc-input-group>
    </div>
</template>

<script>
    import base from "./_elementBase";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/sharedFormElementWords.i18n";
    export default {
        extends: base,
        computed: {
            options() {
                if (this.element.AuxiliaryModel.userList) {
                    return this.element.AuxiliaryModel.userList;
                }
                return [];
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        }
    };
</script>
